import type { IconProps } from './types';

function PuzzlePiece02Icon(props: IconProps) {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M7.41667 0.75L9.81667 3.15C11.4167 -1.05 15.8833 3.41667 11.6833 5.01667L14.0833 7.41667L11.6833 9.81667C10.0833 5.61667 5.61667 10.0833 9.81667 11.6833L7.41667 14.0833L5.01667 11.6833C3.41667 15.8833 -1.05 11.4167 3.15 9.81667L0.75 7.41667L3.15 5.01667C4.75 9.21667 9.21667 4.75 5.01667 3.15L7.41667 0.75Z"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { PuzzlePiece02Icon };
